import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import ChemicalCounterpartCreateFromCSVPage from 'chemistry/ChemicalCounterpartCreateFromCSVPage';
import {
  createSolventsFromFile,
  SOLVENT_LIBRARY_URL,
  TEMPLATE_BULK_SOLVENTS_CSV_LINK,
  validateSolventsFromFile,
} from 'chemistry/ChemistryDAO';
import {getApolloClient} from 'graphql-client/ApolloClient';

import {SOLVENT_LIBRARY_QUERY} from './SolventLibrary';

export default function SolventCreateFromCSVPage(): JSX.Element | null {
  useEffect(() => {
    setWindowTitle('Add solvents');
  }, []);

  return (
    <ChemicalCounterpartCreateFromCSVPage
      counterpartName="solvent"
      libraryUrl={SOLVENT_LIBRARY_URL}
      templateCSVLink={TEMPLATE_BULK_SOLVENTS_CSV_LINK}
      validate={validateSolventsFromFile}
      createFromFile={createSolventsFromFile}
      onImportSuccess={async () => {
        await getApolloClient().refetchQueries({include: [SOLVENT_LIBRARY_QUERY]});
      }}
      dataTestComponent="SolventCreateFromCSVPage"
    />
  );
}
